module.exports = __webpack_public_path__ + "img/scale-manage.db8ea8d4.png";